'use client';
import { jsx } from 'react/jsx-runtime';
import { tokens } from '../../../core/tokens/index.js';
import { spaceTokensMap } from '../../../core/utilities/swan-style.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let c = _object_spread_props(_object_spread({}, spaceTokensMap), {
    'between-sections': tokens.SwanSemSpaceBetweenSections,
    'between-subsections': tokens.SwanSemSpaceBetweenSubsections,
    'between-actions': tokens.SwanSemSpaceBetweenActions,
    'to-actions': tokens.SwanSemSpaceToActions,
    'between-icon-and-text': tokens.SwanSemSpaceBetweenIconAndText
});
const FlexBox = renderWithRef('FlexBox', null, (t, r)=>{
    var { children: n, style: i = {}, alignItems: p, flexWrap: s, flexDirection: l, justifyContent: a, gap: u } = t, b = _object_without_properties(t, [
        "children",
        "style",
        "alignItems",
        "flexWrap",
        "flexDirection",
        "justifyContent",
        "gap"
    ]);
    let f = _object_spread_props(_object_spread({}, i), {
        alignItems: null !== p ? p : void 0,
        flexWrap: null !== s ? s : void 0,
        flexDirection: null !== l ? l : void 0,
        justifyContent: null !== a ? a : void 0,
        gap: null != u ? c[u] : void 0
    });
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        props: _object_spread_props(_object_spread({}, b), {
            style: f
        }),
        classNames: [
            'swan-display-flex'
        ],
        children: n
    });
});

export { FlexBox };
